import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import AdminHomepage from "./pages/HomePage.js";
import Task from "./pages/changeMeter/Task.js";
import HistoryTask from "./pages/changeMeter/History.js";
import TaskDetail from "./pages/changeMeter/TaskDetail.js";
import AddUser from "./pages/userAccess/AddUser.js";
import LoginPage from "./pages/LoginPage.js";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminLayout from "./components/AdminLayout";
import TaskHomePage from "./pages/changeMeter/TaskHomePage.js";
import RevisitHomePage from "./pages/revisit/RevisitHomePage.js";
import AccessHomePage from "./pages/userAccess/AccessHomePage.js";
import ApproveUser from "./pages/userAccess/ApproveUser.js";
import DatabasePage from "./pages/DatabasePage.js";

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Public Route */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected Routes Wrapper */}
        <Route
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<AdminHomepage />} />
          <Route path="/task-home" element={<TaskHomePage />} />
          <Route path="/task" element={<Task />} />
          <Route path="/histori-task" element={<HistoryTask />} />
          <Route path="/task-detail/:id" element={<TaskDetail />} />
          <Route path="/revisit-home" element={<RevisitHomePage />} />
          <Route path="/access" element={<AccessHomePage />} />
          <Route path="/add-user" element={<AddUser />} />
          <Route path="/approve-user" element={<ApproveUser />} />
          <Route path="/database" element={<DatabasePage />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
